import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Container,
} from "@chakra-ui/react";
import { ofiBankGiro, ofiEmail, ofiSwishNr } from "./foreningen";
import { Link } from "react-router-dom";
import { Postings } from "./Posts/Postings";

const newline = "%0D%0A";
const newMemberSubject = "NY medlem <ditt namn>";
const newMemberBody = [
  "Namn: ",
  "Personnummer: ",
  "Adress: ",
  "Mail-adress: ",
  "Mobilnummer: ",
].join(newline);

const currentYear = new Date().getFullYear();

const costSingleMember = 200;
const costFamily = 500;

export function Membership() {
  return (
    <div>
      <Breadcrumb mb={8}>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="..">
            Start
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink>Medlemskap</BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      <Postings
        category="membership"
        showLegend={false}
        alias={{
          year: `${currentYear}`,
          medlemPris: `${costSingleMember}`,
          medlemFamiljPris: `${costFamily}`,
          email: `${ofiEmail}`,
          bankgiro: `${ofiBankGiro}`,
          swish: `${ofiSwishNr}`,
        }}
      />
    </div>
  );
}
